// extracted by mini-css-extract-plugin
module.exports = {"container":"SellerPageProductSort_container__TQMtv","productSortLabel":"SellerPageProductSort_productSortLabel__gi2df typeography_ui14Medium__LuJ8w"};